import { Map, List, fromJS } from 'immutable';
import R, {
  complement,
  equals,
  isEmpty,
  call,
  cond,
  propEq,
  T,
  always,
  ifElse,
} from 'ramda';

const notEquals = complement(equals);

const initialState = new Map({
  companyName: '',
  password: '',
  email: '',
  loading: true,
  isEmailNotEncrypted: false,
  confirmPassword: '',
  country: 'Australia',
  externalDocs: [],
  passwordError: true,
  confirmPasswordError: false,
  companyNameError: true,
  typeAheadCompanies: new List(),
  companyId: '',
  showError: false,
  error: '',
  termsAccepted: false,
  companyType: 'Contractor',
  saving: false,
});
export function contractingSignUp(state = initialState, { type, payload }) {
  switch (type) {
    case 'CONTRACTING_SIGNUP_START':
      return state.set('saving', true);
    case 'GET_EXTERNAL_CONTRACTING_DOCS_SUCCESS':
      const companyName = R.pathOr('', [0, 'companyName'], payload.docs) || '';
      return state
      .set('externalDocs', payload.docs)
      .set('companyName', companyName)
      .set('companyNameError', !Boolean(companyName))
      .set('getExternalDocsDone', true);
    case 'DECRYPT_EMAIL_SUCCESS':
      return state.merge(fromJS(payload)).set('decryptEmailDone', true);
    case 'DECRYPT_EMAIL_FAILED':
      return state.set('loading', false).set('decryptEmailDone', true);
    case 'UPDATE_PROPS_FOR_SHELL_ACCOUNT_SIGNUP':
      return state.merge(fromJS(payload));
    case 'UPDATE_CONTRACTING_SIGN_UP_COMPANY':
      return state.set('companyName', payload)
                  // .set('typeAheadCompanies', new List())
                  .set('companyNameError', isEmpty(payload))
                  .set('companyId', '');
    case 'UPDATE_CONTRACTING_SIGN_UP_PASSWORD':
      return state.set('password', payload)
                  .set('passwordError', isEmpty(payload));
    case 'UPDATE_CONTRACTING_SIGN_UP_PASSWORD_CONFIRMATION':
      return state.set('confirmPassword', payload);
    case 'UPDATE_CONTRACTING_SIGN_UP_COUNTRY':
      return state.set('country', payload);
    case 'UPDATE_TYPE_AHEAD_COMPANIES_STARTED':
      return state.set('searchingCompany', true);
    case 'UPDATE_TYPE_AHEAD_COMPANIES':
      return state.set('typeAheadCompanies', fromJS(payload))
        .set('searchingCompany', false)
        .set('showFoundExistingCompanyInfo', true);
    case 'UPDATE_RESOURCE_ID':
      return state.set('companyId', payload.companyId)
                  .set('companyName', payload.companyName);
    case 'CONTRACTING_SIGNUP_SUCCESS':
      return state.set('showSuccess', true);
    case 'CONTRACTING_SIGNUP_GO_BACK':
      return state.set('showError', false);
    case 'CONTRACTING_SIGN_UP_TERMS_CHECKED':
      return state.set('termsAccepted', !state.get('termsAccepted'));
    case 'CONTRACTING_SIGNUP_FAILED':
      const error = call(
        cond([
          [propEq('error', 'User email already taken'), always('EMAIL')],
          [propEq('error', 'Company name already taken'), ifElse(
            propEq('companyType', 'Contractor'),
              always('COMPANY'),
            always('SUPPLIER')
          )],
          [T, always('GENERIC')],
        ]),
        payload
      );
      return state.merge({
        saving: false,
        showError: true,
        error,
        companyId: payload.companyType === 'Contractor' ? payload.companyId : '',
      });
    case '[asset-landing]OPEN_DIALOG':
      if (payload.type === 'signup' || payload.type === 'dl-wizard') {
        return state.set('email', payload.signupEmail)
          .set('preconfirmed', payload.preconfirmed)
          .set('companyType', payload.viewAs)
          .set('country', payload.country)
          .set('companyName', payload.companyName || '')
          .set('companyNameError', !Boolean(payload.companyName))
          .set('hashToken', payload.hashToken)
          .set('termsAccepted', true);
      }
      return state;
    case '[asset-landing]SIGN_UP_STARTED':
      return state.set('saving', true);
    case '[asset-landing]SIGN_UP_ERROR':
      return state.set('saving', false);
    case '[asset-landing]SIGN_UP_SUCCESS':
      return state.set('saving', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting-sign-up/reducer.js